import {Component, OnInit} from '@angular/core';
import {AppoinmentService} from '../../../src/app/main/care-central/appoinment.service';
import {ActivatedRoute} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { IpsTranslateService } from '@drl/core/localization/ips-translate.service';
import { TranslateService } from '@ngx-translate/core/lib/translate.service';

@Component({
  selector: 'app-joincall',
  templateUrl: './joincall.component.html',
  styleUrls: ['./joincall.component.scss'],
})
export class JoincallComponent implements OnInit {
  output = '<h1>Hello, World!</h1>';
  loading = false;
  joinLinkDet;
  data;
  joinCallProfile;
  joinCallName;
  joinCallMeetingLink;
  guestForm: FormGroup;
  updateStatusCode;
  emailRegx =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  constructor(
    public readonly patientService: AppoinmentService,
    public readonly route: ActivatedRoute,
    private readonly formBuilder: FormBuilder,
    protected readonly translateSvc: IpsTranslateService,
  ) {
    this.translate = this.translateSvc.translate;
  }
  translate: TranslateService;
  ngOnInit() {
    this.loading = true;
    this.guestFrom();
    const queryTypeD = this.route.snapshot.queryParams.type === 'd';
    const queryTypeP = this.route.snapshot.queryParams.type === 'p';
    const queryTypeG = this.route.snapshot.queryParams.type === 'g';
    if (queryTypeD || queryTypeP || queryTypeG) {
      this.data = {
        appointmentId:
          this.route.snapshot.queryParams.appointmentId +
          this.route.snapshot.queryParams.type,
      };
    } else {
      this.data = {
        appointmentId: null,
      };
    }
    this.patientService.getJoinCallLink(this.data).subscribe(res => {
      this.joinLinkDet = res.responseResult;
      this.joinCallProfile = this.joinLinkDet.profile;
      this.joinCallName = this.joinLinkDet.name;
      this.joinCallMeetingLink = this.joinLinkDet.meetingLink;
      this.loading = false;
    });
  }

  guestFrom() {
    const minEmailLength = 5;
    const maxEmailLength = 50;
    this.guestForm = this.formBuilder.group({
      guestName: [null, [Validators.required]],
      guestEmail: [
        null,
        [
          Validators.required,
          Validators.minLength(minEmailLength),
          Validators.maxLength(maxEmailLength),
          Validators.pattern(this.emailRegx),
        ],
      ],
    });
  }
  get f() {
    return this.guestForm.controls;
  }

  getGuestMeetingLink() {
    if (this.route.snapshot.queryParams.type === 'g') {
      this.data = {
        appointmentId:
          this.route.snapshot.queryParams.appointmentId +
          this.route.snapshot.queryParams.type,
        guestName: this.guestForm.value.guestName,
        guestEmail: this.guestForm.value.guestEmail,
      };
    }
    this.patientService.getJoinCallLink(this.data).subscribe(res => {
      this.joinLinkDet = res.responseResult;
      this.joinCallProfile = this.joinLinkDet.profile;
      this.joinCallName = this.joinLinkDet.name;
      this.joinCallMeetingLink = this.joinLinkDet.meetingLink;
      this.loading = false;
      this.updateAppointmnentStatus(
        this.route.snapshot.queryParams.appointmentId,
      );
    });
  }
  updateStatus() {
    this.data = {
      appointmentId:
        this.route.snapshot.queryParams.appointmentId +
        this.route.snapshot.queryParams.type,
    };
    this.updateAppointmnentStatus(
      this.route.snapshot.queryParams.appointmentId,
    );
  }

  updateAppointmnentStatus(val: string) {
    const body = {
      appointmentId: val,
      status: 'Ongoing',
      type: this.route.snapshot.queryParams.type
    };
    this.patientService.updateAppointmnentEncode(body).subscribe(res => {
      this.updateStatusCode = res;
      window.location.href=this.joinCallMeetingLink;
    });
  }
}
